














































































import Vue from 'vue';
import store from '../store/store';
import moment from 'moment';
import {
  mapState,
  mapActions
} from 'vuex';

export default Vue.extend({
  name: 'CheckDialog',
  props: ['isShowCheck', 'checkedRow'],
  data() {
    return {
        search: {
            title: '',
            author: '',
            taskName: '',
            endTime: '',
            beginTime: '',
            offset: 0,
            limit: 5
        },
        checkRow: {},
        checkedList: [],
        listLoading: false,
        pageObj: {
          total: 0,
          pageIndex: 1,
          pageSize: 5
        },
        pageSizeList: [5, 20, 50]
    };
  },
  computed: mapState({
    checkHomeUrl: (state: any) => store.getters.getCheckHomeUrl
  }),
  watch: {
      isShowCheck(val) {
          if(val) {
              this.getCheckResult();
          }
      }
  },
  methods: {
      getSearch() {
      this.pageObj.pageIndex = 1;
      this.search.offset = 0;
      this.search.limit = 5;
      this.getCheckResult();
      },
      // 查看在线报告
      getOnLineReportLink(row: any) {
          const checkTypeTable: any = {
              WFDB: 'JA',
              OneByOne: 'JAYD'
          };

          if(row.checkType === "OneByOne"){
              window.open(`${this.checkHomeUrl}reportweb/?reportId=${row.checkId}&productId=${checkTypeTable[row.checkType]}&checkType=OneByOne`, '_blank');
          } else {
              window.open(`${this.checkHomeUrl}reportweb/?reportId=${row.checkId}&productId=${checkTypeTable[row.checkType]}&reportType=originalText`, '_blank');
          }
      },
      getCheckResult() {
          this.$http.get('/api/Check/CheckResultList', {
              params: this.search
          }).then((data: any) => {
              this.checkedList = data.result;
              this.pageObj.total = data.total;
              
              this.checkRow = {};
          });
      },
      changeShowDialog() {
          this.$emit('update:isShowCheck', false);
      },
      // 设置检测时间
      setCheckTime(num: any, type: string) {
          this.search.endTime = moment(new Date()).format('YYYY-MM-DD');
          this.search.beginTime = moment(this.search.endTime).subtract(num, type).format('YYYY-MM-DD');
      },
      submitCheck() {
          if((this.checkRow as any).checkId) {
              this.$emit('update:checkedRow', [this.checkRow]);
              this.changeShowDialog();
          } else {
              this.$message({
                  message: '请选择一篇已检测文献！',
                  type: 'error'
              });
          }
      },
      // 改变分页size
      handleSizeChange(val: number) {
          this.pageObj.pageSize = val;
          this.pageObj.pageIndex = 1;
          this.setSearchPage();
          this.getCheckResult();
      },
      // 改变当前页
      handleCurrentChange(val: number) {
          this.pageObj.pageIndex = val;
          this.setSearchPage();
          this.getCheckResult();
      },
      // 设置分页
      setSearchPage() {
          this.search.offset = (this.pageObj.pageIndex - 1) * this.pageObj.pageSize;
          this.search.limit = this.pageObj.pageSize;
      },
      clear() {
          this.search = {
              title: '',
              author: '',
              taskName: '',
              endTime: '',
              beginTime: '',
              offset: 0,
              limit: 5
          };
          this.search.endTime = moment().format('YYYY-MM-DD');
          this.search.beginTime = moment(this.search.endTime).subtract(7, 'day').format('YYYY-MM-DD');
      }
  },
  mounted() {
      this.search.endTime = moment().format('YYYY-MM-DD');
      this.search.beginTime = moment(this.search.endTime).subtract(7, 'day').format('YYYY-MM-DD');
  }
});
